import Cookies from 'js-cookie';
import {v4 as uuidv4} from 'uuid';
import {getTemporaryForm, getUploadedFiles} from '../DNFORM-utils/DNFORM-api';
import {
	SESSION_COOKIE,
	FILE_INPUT_STATES,
	STEP_REF_PREFIX,
	SESSION_META
} from '../DNFORM-utils/DNFORM-constants';
import {isObject, isPhoneNumberObject} from '../DNFORM-utils/DNFORM-utils';

export const sessionMixin = {
	data() {
		return {
			STEP_REF_PREFIX,
			sessionToken: ''
		};
	},
	watch: {
		currentStep() {
			this.$nextTick(this.getUploadedFiles);
		}
	},
	mounted() {
		this.handleSession();
	},
	methods: {
		handleSession() {
			const sessions = this.getSessionCookie();

			if (sessions) {
				const sessionTokenOfForm = this.getSessionToken(sessions);

				if (sessionTokenOfForm) {
					this.sessionToken = sessionTokenOfForm;

					if (this.isMultiStepForm) {
						this.getSessionData();
					}
				} else {
					this.extendSessionCookie(sessions);
				}
			} else {
				this.createSessionCookie();
			}
		},
		getSessionCookie() {
			return Cookies.get(SESSION_COOKIE.NAME);
		},
		setSessionCookie(content) {
			Cookies.set(SESSION_COOKIE.NAME, content, {expires: SESSION_COOKIE.LIFESPAN_IN_DAYS});
		},
		createSessionCookie() {
			this.sessionToken = uuidv4();
			const cookieContent = `${this.formId}${SESSION_COOKIE.KEY_VALUE_SEPARATOR}${this.sessionToken}`;
			this.setSessionCookie(cookieContent);
		},
		extendSessionCookie(sessions) {
			this.sessionToken = uuidv4();
			const cookieContent = `${sessions}${SESSION_COOKIE.SESSION_SEPARATOR}${this.formId}=${this.sessionToken}`;
			this.setSessionCookie(cookieContent);
		},
		removeSessionFromCookie() {
			const sessions = this.getSessionCookie();
			const sessionsArray = sessions.split(SESSION_COOKIE.SESSION_SEPARATOR);

			sessionsArray.forEach((session, index) => {
				const formId = session.split(SESSION_COOKIE.KEY_VALUE_SEPARATOR)[0];

				if (formId === this.formId) {
					sessionsArray.splice(index, 1);
					const cookieContent = sessionsArray.join(SESSION_COOKIE.SESSION_SEPARATOR);
					this.setSessionCookie(cookieContent);
				}
			});
		},
		getSessionToken(sessionsString) {
			let result = '';
			const sessionsArray = sessionsString.split(SESSION_COOKIE.SESSION_SEPARATOR);

			sessionsArray.forEach((session) => {
				const splittedSession = session.split(SESSION_COOKIE.KEY_VALUE_SEPARATOR);

				if (splittedSession.length === 2) {
					const formId = splittedSession[0];

					if (formId === this.formId) {
						result = splittedSession[1];
					}
				}
			});

			return result;
		},
		getSessionData() {
			getTemporaryForm(this.formId, this.sessionToken)
				.then((response) => {
					if (response.data) {
						// In this case we submitted temporary data at least once so the change of currentStep
						// will trigger the getUploadedFiles method
						this.model = this.normalizeModel(response.data);

						const metaData = response.data[SESSION_META.OBJECT];

						if (metaData) {
							this.metaData = metaData;
							this.handleSessionMetaData();
						}
					} else {
						this.getUploadedFiles();
					}
				})
				.catch((error) => {
					console.error('Failed to get session data', error, 'Params:', {formId: this.formId, sessionToken: this.sessionToken});
				});
		},
		getUploadedFiles() {
			const stepRef = this.$refs[`${STEP_REF_PREFIX}${this.currentStep}`];

			if (stepRef) {
				const fileInputs = stepRef.querySelectorAll('input[type=file]');

				if (fileInputs.length) {
					const fileInputIds = Array.from(fileInputs).map((fileInput) => fileInput.id);
					const getUploadedFilesRequests = fileInputIds.map((fileInputId) => getUploadedFiles(this.formId, this.sessionToken, fileInputId));

					Promise.all(getUploadedFilesRequests)
						.then((response) => {
							this.setUploadedFiles(response);
						})
						.catch((error) => {
							const fileInputId = this.getFileInputIdFromUrl(error.response.config.url);
							console.error('Failed to get uploaded files', error,
								'Params:', {formId: this.formId, sessionToken: this.sessionToken, fileInputId});
						});
				}

			}
		},
		setUploadedFiles(allResponse) {
			allResponse.forEach((response) => {
				if (response.data.length) {
					const fileInputId = this.getFileInputIdFromUrl(response.config.url);
					this.setFileInputState(FILE_INPUT_STATES.UPLOADED_FILES, fileInputId, response.data);
					// We need File objects in model instead of filenames to make it consistent
					this.convertFilenamesToFileObjectsInModel(fileInputId, response.data);
				}
			});
		},
		handleSessionMetaData() {
			const lastStep = this.metaData[SESSION_META.LAST_STEP];

			if (lastStep) {
				this.currentStep = lastStep;
				this.setDoneSteps(lastStep);
			}
		},
		normalizeModel(model) {
			let result = model;
			// Remove meta
			result = Object.keys(model)
				.filter(step => step !== SESSION_META.OBJECT)
				.reduce((obj, key) => {
					obj[key] = model[key];
					return obj;
				}, {});
			// Convert objects back to arrays unless it is a phone number object
			for (const [step, inputs] of Object.entries(result)) {
				for (const [inputId, inputValue] of Object.entries(inputs)) {
					if (isObject(inputValue) && !isPhoneNumberObject(inputValue)) {
						result[step][inputId] = Object.values(inputValue);
					}
				}
			}

			return result;
		},
		convertFilenamesToFileObjectsInModel(fileInputId, filenames) {
			this.model[this.currentStep][fileInputId] = filenames.map((filename) => new File([], filename));
		},
		setDoneSteps(lastStep) {
			for (let i = 1; i < lastStep; i++) {
				this.addStepToDoneSteps(i);
			}
		},
		getFileInputIdFromUrl(url) {
			return url.split('/').pop();
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-mixins/DNFORM-session-mixin.js